import React from "react";
import { Wrapper } from "../../shared/Wrapper";
import { Choices } from "../../shared/Choices";

/**
 * @param {{
 *  question: string;
 *  description?: string;
 *  required?: boolean;
 *  value: string;
 *  onChange: (value: string) => void;
 * }} param0
 */
export function QuestionBinary({
  question,
  description,
  required,
  value,
  onChange,
}) {
  return (
    <Wrapper title={question} description={description} required={required}>
      <Choices
        options={[
          { id: 1, text: "Yes" },
          { id: 2, text: "No" },
        ]}
        values={value ? [value] : []}
        onChange={(options) => onChange(options?.[0])}
      />
    </Wrapper>
  );
}
